import * as types from '../actions/_actionTypes'
import initialState from './_initialReducerState'

export default function approvalrequestContentReducer(state = initialState.approvalrequestContent || [], action: any) {
  switch (action.type) {
    case types.SAVE_APPROVALREQUESTCONTENT_SUCCESS:
      return action.approvalrequestContent
    default:
      return state
  }
}
